/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayMatchNarrativeDtoSchema } from "./goodLuck/core/DTOs/replayMatchNarrativeDtoSchema.ts";
import { z } from "zod/v4";

export const getBracketsMatchesMatchidReplayNarrativePathParamsSchema =
  z.object({
    matchId: z.string(),
  });

/**
 * @description OK
 */
export const getBracketsMatchesMatchidReplayNarrative200Schema = z.array(
  z.lazy(() => goodLuckCoreDTOsReplayMatchNarrativeDtoSchema),
);

export const getBracketsMatchesMatchidReplayNarrativeQueryResponseSchema =
  getBracketsMatchesMatchidReplayNarrative200Schema;
